export default "__VITE_ASSET__BJ2bHthw__"